import { render, staticRenderFns } from "./faceStudentstatistics.vue?vue&type=template&id=0361546b&scoped=true"
import script from "./faceStudentstatistics.vue?vue&type=script&lang=js"
export * from "./faceStudentstatistics.vue?vue&type=script&lang=js"
import style0 from "./faceStudentstatistics.vue?vue&type=style&index=0&id=0361546b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361546b",
  null
  
)

export default component.exports